export default __webpack_public_path__ + "static/media/MA.e091e6c4.svg";